/** @module csi/widget/_svg/_ShapeDistribute */
define([
	"dojo/_base/declare",
	"dijit/form/Button",
	"csi/_base/underscore",
	"csi",
	"./_Plugin",
	"./util"
], function(declare,Button,_,csi,_Plugin, util) {

	return declare([Button, _Plugin], {
		/**
		 * Flag indicating if it's horizontal distribution.
		 * @property {Boolean}
		 */
		bHorizontal: false,

		/**
		 * Plugin is enabled only if there are 3 or more shapes selected.
		 * @param {Array.<Shape>} shapes - selected shapes
		 * @param {Object} shapeAttrs - Shape attributes
		 * @param {Object} textAttrs - Text attributes
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			return this.inherited(arguments) && shapes && util.unlockedShapedCount(shapes) >= 3;
		},

		/**
		 * Align shape as per alignement option selected.
		 *
		 * @param {Event} e - Click event
		 */
		onClick: function(e) {
			this.editor.distributeObjects(this.bHorizontal);
		}
	});
});
